import React, { useState } from 'react';
import { Col, Button, Row, Container, Card, Form, Spinner } from 'react-bootstrap';
import CryptoJS from 'crypto-js'; // Make sure to import CryptoJS
import Cookies from 'js-cookie';
import { LEGACY_DOMAIN } from 'constants/index';

export default function Login() {
  const [credentials, setCredentials] = useState({
    userId: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const login = async () => {
    // Validate the form input here if needed

    setLoading(true);

    try {
      // Encrypt the password using CryptoJS
      let encryptedPwd = CryptoJS.SHA1(credentials.password).toString();
      // Fetch the encryption data from the server
      const encryptionResponse = await fetch(`${LEGACY_DOMAIN}/encrypt`);
      if (!encryptionResponse.ok) {
        throw new Error('Encryption error');
      }
      let encryptionData = await encryptionResponse.text(); // Read the response as text
      encryptionData = encryptionData.replace(/"/g, '');
      if (encryptionData === 'Cannot connect to the DB') {
        // Handle DB connection error if needed
        throw new Error('Cannot connect to the DB');
      }
      // Combine the password with the encryption data
      encryptedPwd += encryptionData;
      // Encrypt the combined password again
      const finalEncryptedPwd = CryptoJS.SHA1(encryptedPwd).toString();
      // Make the login request
      //tennisballcricket.com/dologin/adi501/2df607d3aa80f469e84c33e8d236727a1d855255/1
      //tennisballcricket.com/dologin/adi501/7c16940154633b28f1b8a083f95d5ea6d87269d4/1
      const loginResponse = await fetch(`${LEGACY_DOMAIN}/dologin/${credentials.userId}/${finalEncryptedPwd}/1`);
      if (!loginResponse.ok) {
        throw new Error('Login error');
      }
      const loginData = await loginResponse.json();
      /**
       FullName : "Adi V" LastLogin : "07 Feb 2020 09:43 PM" Player : "21030" PlayerRole : "1" Role : "5" TeamId : "469" UserId : "22039" UserName : "adi501" fpass : "sc#c3b54Et81" home : "home" status : "1" token : "UnkxMDMxNzM3MzQ="
       */

      if (loginData.Status === "There Was An Error..!!") {
        // Handle error if needed
        throw new Error('There Was An Error..!!');
      }

      // Handle successful login and redirect if needed

      if (loginData.status !== "0") {
        // Define the cookies you want to set
        const cookiesToSet = {
          token: loginData.token,
          PlayerId: loginData.Player,
          UserName: loginData.UserName,
          RegiuserName: credentials.txtUser,
          UserId: loginData.UserId,
          TeamId: loginData.TeamId,
          RoleId: loginData.Role,
          PlayerRole: loginData.PlayerRole,
          lastlogin: loginData.LastLogin,
          FullName: loginData.FullName,
        };

        // Set the cookies
        Object.entries(cookiesToSet).forEach(([cookieName, cookieValue]) => {
          Cookies.set(cookieName, cookieValue, { expires: 1 });
        });
      }

      if (loginData.status === "14") {
        Cookies.set('oldpassword', loginData.fpass, { expires: 1 });
        window.location = server + "/forgotpassword";
        return false;
      }

      if (loginData.status === "4" || loginData.status === "0") {
        Cookies.set('RACTIVE', '1', { expires: 1 });
      }

      if (loginData.status === "0") {
        Cookies.set('UserId', loginData.UserId, { expires: 1 });
        Cookies.set('RACTIVE', '1', { expires: 1 });
        window.location = server + "/active";
      }

    } catch (error) {
      // Handle any errors that occur during the login process
      console.error('Error:', error);
      // Display an error message to the user if needed
    } finally {
      setLoading(false);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFocus = (name) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Perform form validation
    const errors = {};
    if (!credentials.userId) {
      errors.userId = 'Username is required.';
    }
    if (!credentials.password) {
      errors.password = 'Password is required.';
    }

    if (Object.keys(errors).length === 0) {
      setLoading(true);

      // Send the request to the backend server
      fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(credentials),
      })
        .then((response) => {
          // Handle the response from the server
          // Redirect or display success/error message based on response
        })
        .catch((error) => {
          // Handle any errors that occur during the request
          setErrors({ userId: '', password: 'Invalid username or password.' });
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setErrors(errors);
    }
  };

  return (
    <div>
      <Container>
        <Row className="vh-80 d-flex justify-content-center align-items-center mb-4">
          <Col xs={12} md={8} lg={5}>
            <div className="border border-3 border-primary"></div>
            <Card className="shadow">
              <Card.Body>
                <div className="mb-3 mt-md-4">
                  <h3 className="fw-bold mb-2 text-center">Login</h3>
                  <p className="mb-2 text-center">Please enter your login and password!</p>
                  <div className="mb-3">
                    <Form onSubmit={handleSubmit}>
                      <Form.Group className="mb-3" controlId="formBasicEmail">
                        <Form.Label className="text-center">Username</Form.Label>
                        <Form.Control
                          type="userid"
                          placeholder="Enter User Id"
                          name="userId"
                          value={credentials.userId}
                          onChange={handleChange}
                          onFocus={() => handleFocus('userId')}
                          isInvalid={!!errors.userId}
                        />
                        <Form.Control.Feedback type="invalid">{errors.userId}</Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group className="mb-3" controlId="formBasicPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                          type="password"
                          placeholder="Password"
                          name="password"
                          value={credentials.password}
                          onChange={handleChange}
                          onFocus={() => handleFocus('password')}
                          isInvalid={!!errors.password}
                        />
                        <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        className="mb-3"
                        controlId="formBasicCheckbox"
                      >
                        <p className="small">
                          <a className="text-primary" href="/forgotpassword">
                            Forgot password?
                          </a>
                        </p>
                      </Form.Group>
                      <div className="d-grid">
                        <Button variant="primary" type="submit" onClick={login} disabled={loading}>
                          {loading ? (
                            <Spinner animation="border" size="sm" role="status" aria-hidden="true" />
                          ) : (
                            'Login'
                          )}
                        </Button>
                      </div>
                    </Form>
                    <div className="mt-3">
                      <p className="mb-0  text-center">
                        Don't have an account?{' '}
                        <a href="/signup" className="text-primary fw-bold">
                          Sign Up
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
